<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Дата прекращения</div>
            <div class="dx-field-value">
                <dx-date-box :value="data.ac_egr_termination_date" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { DxDateBox } from 'devextreme-vue';

const data = inject('serverData');
</script>
